"use client";

import api from "@/api";
import useSWR from "swr";

type PublicSaleData = {
  nome: string;
  email: string;
  cpf: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cep: string;
  telefone: string;
  msisdn: string;
  complemento: string;
  segmento: string;
  status: string;
  plano_id: number;
  id: number;
  tipo: string;
  jornada_uuid?: string;
};

export const GetSaleFetch = (saleId: string, key: string) => {
  const { data, mutate, isLoading, error } = useSWR<PublicSaleData>(
    `getSale_${saleId}_${key}`,
    async (): Promise<PublicSaleData> => {
      const { data } = await api.get<PublicSaleData>(
        `/core/vendas/${saleId}/${key}`,
      );

      return data;
    },
  );

  return { data, mutate, isLoading, error };
};
